/**
 * DXCC Entity Code Enumeration per ADIF 3.1.6 specification.
 * Maps DXCC numeric codes to their official ADIF entity names.
 *
 * Source: https://www.adif.org/316/ADIF_316.htm#DXCC_Entity_Code_Enumeration
 */

// cSpell:disable
export const DXCC_ENTITIES: Map<number, string> = new Map([
  [1, "CANADA"],
  [2, "ABU AIL IS."],
  [3, "AFGHANISTAN"],
  [4, "AGALEGA & ST. BRANDON IS."],
  [5, "ALAND IS."],
  [6, "ALASKA"],
  [7, "ALBANIA"],
  [8, "ALDABRA"],
  [9, "AMERICAN SAMOA"],
  [10, "AMSTERDAM & ST. PAUL IS."],
  [11, "ANDAMAN & NICOBAR IS."],
  [12, "ANGUILLA"],
  [13, "ANTARCTICA"],
  [14, "ARMENIA"],
  [15, "ASIATIC RUSSIA"],
  [16, "NEW ZEALAND SUBANTARCTIC ISLANDS"],
  [17, "AVES I."],
  [18, "AZERBAIJAN"],
  [19, "BAJO NUEVO"],
  [20, "BAKER & HOWLAND IS."],
  [21, "BALEARIC IS."],
  [22, "PALAU"],
  [23, "BLENHEIM REEF"],
  [24, "BOUVET"],
  [25, "BRITISH NORTH BORNEO"],
  [26, "BRITISH SOMALILAND"],
  [27, "BELARUS"],
  [28, "CANAL ZONE"],
  [29, "CANARY IS."],
  [30, "CELEBE & MOLUCCA IS."],
  [31, "C. KIRIBATI (BRITISH PHOENIX IS.)"],
  [32, "CEUTA & MELILLA"],
  [33, "CHAGOS IS."],
  [34, "CHATHAM IS."],
  [35, "CHRISTMAS I."],
  [36, "CLIPPERTON I."],
  [37, "COCOS I."],
  [38, "COCOS (KEELING) IS."],
  [39, "COMOROS"],
  [40, "CRETE"],
  [41, "CROZET I."],
  [42, "DAMAO, DIU"],
  [43, "DESECHEO I."],
  [44, "DESROCHES"],
  [45, "DODECANESE"],
  [46, "EAST MALAYSIA"],
  [47, "EASTER I."],
  [48, "E. KIRIBATI (LINE IS.)"],
  [49, "EQUATORIAL GUINEA"],
  [50, "MEXICO"],
  [51, "ERITREA"],
  [52, "ESTONIA"],
  [53, "ETHIOPIA"],
  [54, "EUROPEAN RUSSIA"],
  [55, "FARQUHAR"],
  [56, "FERNANDO DE NORONHA"],
  [57, "FRENCH EQUATORIAL AFRICA"],
  [58, "FRENCH INDO-CHINA"],
  [59, "FRENCH WEST AFRICA"],
  [60, "BAHAMAS"],
  [61, "FRANZ JOSEF LAND"],
  [62, "BARBADOS"],
  [63, "FRENCH GUIANA"],
  [64, "BERMUDA"],
  [65, "BRITISH VIRGIN IS."],
  [66, "BELIZE"],
  [67, "FRENCH INDIA"],
  [68, "KUWAIT/SAUDI ARABIA NEUTRAL ZONE"],
  [69, "CAYMAN IS."],
  [70, "CUBA"],
  [71, "GALAPAGOS IS."],
  [72, "DOMINICAN REPUBLIC"],
  [74, "EL SALVADOR"],
  [75, "GEORGIA"],
  [76, "GUATEMALA"],
  [77, "GRENADA"],
  [78, "HAITI"],
  [79, "GUADELOUPE"],
  [80, "HONDURAS"],
  [81, "GERMANY"],
  [82, "JAMAICA"],
  [84, "MARTINIQUE"],
  [85, "BONAIRE, CURACAO"],
  [86, "NICARAGUA"],
  [88, "PANAMA"],
  [89, "TURKS & CAICOS IS."],
  [90, "TRINIDAD & TOBAGO"],
  [91, "ARUBA"],
  [93, "GEYSER REEF"],
  [94, "ANTIGUA & BARBUDA"],
  [95, "DOMINICA"],
  [96, "MONTSERRAT"],
  [97, "ST. LUCIA"],
  [98, "ST. VINCENT"],
  [99, "GLORIOSO IS."],
  [100, "ARGENTINA"],
  [101, "GOA"],
  [102, "GOLD COAST, TOGOLAND"],
  [103, "GUAM"],
  [104, "BOLIVIA"],
  [105, "GUANTANAMO BAY"],
  [106, "GUERNSEY"],
  [107, "GUINEA"],
  [108, "BRAZIL"],
  [109, "GUINEA-BISSAU"],
  [110, "HAWAII"],
  [111, "HEARD I."],
  [112, "CHILE"],
  [113, "IFNI"],
  [114, "ISLE OF MAN"],
  [115, "ITALIAN SOMALILAND"],
  [116, "COLOMBIA"],
  [117, "ITU HQ"],
  [118, "JAN MAYEN"],
  [119, "JAVA"],
  [120, "ECUADOR"],
  [122, "JERSEY"],
  [123, "JOHNSTON I."],
  [124, "JUAN DE NOVA, EUROPA"],
  [125, "JUAN FERNANDEZ IS."],
  [126, "KALININGRAD"],
  [127, "KAMARAN IS."],
  [128, "KARELO-FINNISH REPUBLIC"],
  [129, "GUYANA"],
  [130, "KAZAKHSTAN"],
  [131, "KERGUELEN IS."],
  [132, "PARAGUAY"],
  [133, "KERMADEC IS."],
  [134, "KINGMAN REEF"],
  [135, "KYRGYZSTAN"],
  [136, "PERU"],
  [137, "REPUBLIC OF KOREA"],
  [138, "KURE I."],
  [139, "KURIA MURIA I."],
  [140, "SURINAME"],
  [141, "FALKLAND IS."],
  [142, "LAKSHADWEEP IS."],
  [143, "LAOS"],
  [144, "URUGUAY"],
  [145, "LATVIA"],
  [146, "LITHUANIA"],
  [147, "LORD HOWE I."],
  [148, "VENEZUELA"],
  [149, "AZORES"],
  [150, "AUSTRALIA"],
  [151, "MALYJ VYSOTSKIJ I."],
  [152, "MACAO"],
  [153, "MACQUARIE I."],
  [154, "YEMEN ARAB REPUBLIC"],
  [155, "MALAYA"],
  [157, "NAURU"],
  [158, "VANUATU"],
  [159, "MALDIVES"],
  [160, "TONGA"],
  [161, "MALPELO I."],
  [162, "NEW CALEDONIA"],
  [163, "PAPUA NEW GUINEA"],
  [164, "MANCHURIA"],
  [165, "MAURITIUS"],
  [166, "MARIANA IS."],
  [167, "MARKET REEF"],
  [168, "MARSHALL IS."],
  [169, "MAYOTTE"],
  [170, "NEW ZEALAND"],
  [171, "MELLISH REEF"],
  [172, "PITCAIRN I."],
  [173, "MICRONESIA"],
  [174, "MIDWAY I."],
  [175, "FRENCH POLYNESIA"],
  [176, "FIJI"],
  [177, "MINAMI TORISHIMA"],
  [178, "MINERVA REEF"],
  [179, "MOLDOVA"],
  [180, "MOUNT ATHOS"],
  [181, "MOZAMBIQUE"],
  [182, "NAVASSA I."],
  [183, "NETHERLANDS BORNEO"],
  [184, "NETHERLANDS NEW GUINEA"],
  [185, "SOLOMON IS."],
  [186, "NEWFOUNDLAND, LABRADOR"],
  [187, "NIGER"],
  [188, "NIUE"],
  [189, "NORFOLK I."],
  [190, "SAMOA"],
  [191, "NORTH COOK IS."],
  [192, "OGASAWARA"],
  [193, "OKINAWA (RYUKYU IS.)"],
  [194, "OKINO TORI-SHIMA"],
  [195, "ANNOBON I."],
  [196, "PALESTINE"],
  [197, "PALMYRA & JARVIS IS."],
  [198, "PAPUA TERRITORY"],
  [199, "PETER 1 I."],
  [200, "PORTUGUESE TIMOR"],
  [201, "PRINCE EDWARD & MARION IS."],
  [202, "PUERTO RICO"],
  [203, "ANDORRA"],
  [204, "REVILLAGIGEDO"],
  [205, "ASCENSION I."],
  [206, "AUSTRIA"],
  [207, "RODRIGUES I."],
  [208, "RUANDA-URUNDI"],
  [209, "BELGIUM"],
  [210, "SAAR"],
  [211, "SABLE I."],
  [212, "BULGARIA"],
  [213, "SAINT MARTIN"],
  [214, "CORSICA"],
  [215, "CYPRUS"],
  [216, "SAN ANDRES & PROVIDENCIA"],
  [217, "SAN FELIX & SAN AMBROSIO"],
  [218, "CZECHOSLOVAKIA"],
  [219, "SAO TOME & PRINCIPE"],
  [220, "SARAWAK"],
  [221, "DENMARK"],
  [222, "FAROE IS."],
  [223, "ENGLAND"],
  [224, "FINLAND"],
  [225, "SARDINIA"],
  [226, "SAUDI ARABIA/IRAQ NEUTRAL ZONE"],
  [227, "FRANCE"],
  [228, "SERRANA BANK & RONCADOR CAY"],
  [229, "GERMAN DEMOCRATIC REPUBLIC"],
  [230, "FEDERAL REPUBLIC OF GERMANY"],
  [231, "SIKKIM"],
  [232, "SOMALIA"],
  [233, "GIBRALTAR"],
  [234, "SOUTH COOK IS."],
  [235, "SOUTH GEORGIA I."],
  [236, "GREECE"],
  [237, "GREENLAND"],
  [238, "SOUTH ORKNEY IS."],
  [239, "HUNGARY"],
  [240, "SOUTH SANDWICH IS."],
  [241, "SOUTH SHETLAND IS."],
  [242, "ICELAND"],
  [243, "PEOPLE'S DEMOCRATIC REP. OF YEMEN"],
  [244, "SOUTHERN SUDAN"],
  [245, "IRELAND"],
  [246, "SOVEREIGN MILITARY ORDER OF MALTA"],
  [247, "SPRATLY IS."],
  [248, "ITALY"],
  [249, "ST. KITTS & NEVIS"],
  [250, "ST. HELENA"],
  [251, "LIECHTENSTEIN"],
  [252, "ST. PAUL I."],
  [253, "ST. PETER & ST. PAUL ROCKS"],
  [254, "LUXEMBOURG"],
  [255, "ST. MAARTEN, SABA, ST. EUSTATIUS"],
  [256, "MADEIRA IS."],
  [257, "MALTA"],
  [258, "SUMATRA"],
  [259, "SVALBARD"],
  [260, "MONACO"],
  [261, "SWAN IS."],
  [262, "TAJIKISTAN"],
  [263, "NETHERLANDS"],
  [264, "TANGIER"],
  [265, "NORTHERN IRELAND"],
  [266, "NORWAY"],
  [267, "TERRITORY OF NEW GUINEA"],
  [268, "TIBET"],
  [269, "POLAND"],
  [270, "TOKELAU IS."],
  [271, "TRIESTE"],
  [272, "PORTUGAL"],
  [273, "TRINDADE & MARTIM VAZ IS."],
  [274, "TRISTAN DA CUNHA & GOUGH I."],
  [275, "ROMANIA"],
  [276, "TROMELIN I."],
  [277, "ST. PIERRE & MIQUELON"],
  [278, "SAN MARINO"],
  [279, "SCOTLAND"],
  [280, "TURKMENISTAN"],
  [281, "SPAIN"],
  [282, "TUVALU"],
  [283, "UK SOVEREIGN BASE AREAS ON CYPRUS"],
  [284, "SWEDEN"],
  [285, "VIRGIN IS."],
  [286, "UGANDA"],
  [287, "SWITZERLAND"],
  [288, "UKRAINE"],
  [289, "UNITED NATIONS HQ"],
  [291, "UNITED STATES OF AMERICA"],
  [292, "UZBEKISTAN"],
  [293, "VIET NAM"],
  [294, "WALES"],
  [295, "VATICAN"],
  [296, "SERBIA"],
  [297, "WAKE I."],
  [298, "WALLIS & FUTUNA IS."],
  [299, "WEST MALAYSIA"],
  [301, "W. KIRIBATI (GILBERT IS.)"],
  [302, "WESTERN SAHARA"],
  [303, "WILLIS I."],
  [304, "BAHRAIN"],
  [305, "BANGLADESH"],
  [306, "BHUTAN"],
  [307, "ZANZIBAR"],
  [308, "COSTA RICA"],
  [309, "MYANMAR"],
  [312, "CAMBODIA"],
  [315, "SRI LANKA"],
  [318, "CHINA"],
  [321, "HONG KONG"],
  [324, "INDIA"],
  [327, "INDONESIA"],
  [330, "IRAN"],
  [333, "IRAQ"],
  [336, "ISRAEL"],
  [339, "JAPAN"],
  [342, "JORDAN"],
  [344, "DEMOCRATIC PEOPLE'S REP. OF KOREA"],
  [345, "BRUNEI DARUSSALAM"],
  [348, "KUWAIT"],
  [354, "LEBANON"],
  [363, "MONGOLIA"],
  [369, "NEPAL"],
  [370, "OMAN"],
  [372, "PAKISTAN"],
  [375, "PHILIPPINES"],
  [376, "QATAR"],
  [378, "SAUDI ARABIA"],
  [379, "SEYCHELLES"],
  [381, "SINGAPORE"],
  [382, "DJIBOUTI"],
  [384, "SYRIA"],
  [386, "TAIWAN"],
  [387, "THAILAND"],
  [390, "TURKEY"],
  [391, "UNITED ARAB EMIRATES"],
  [400, "ALGERIA"],
  [401, "ANGOLA"],
  [402, "BOTSWANA"],
  [404, "BURUNDI"],
  [406, "CAMEROON"],
  [408, "CENTRAL AFRICA"],
  [409, "CAPE VERDE"],
  [410, "CHAD"],
  [411, "COMOROS"],
  [412, "REPUBLIC OF THE CONGO"],
  [414, "DEMOCRATIC REPUBLIC OF THE CONGO"],
  [416, "BENIN"],
  [420, "GABON"],
  [422, "THE GAMBIA"],
  [424, "GHANA"],
  [428, "COTE D'IVOIRE"],
  [430, "KENYA"],
  [432, "LESOTHO"],
  [434, "LIBERIA"],
  [436, "LIBYA"],
  [438, "MADAGASCAR"],
  [440, "MALAWI"],
  [442, "MALI"],
  [444, "MAURITANIA"],
  [446, "MOROCCO"],
  [450, "NIGERIA"],
  [452, "ZIMBABWE"],
  [453, "REUNION I."],
  [454, "RWANDA"],
  [456, "SENEGAL"],
  [458, "SIERRA LEONE"],
  [460, "ROTUMA I."],
  [462, "REPUBLIC OF SOUTH AFRICA"],
  [464, "NAMIBIA"],
  [466, "SUDAN"],
  [468, "KINGDOM OF ESWATINI"],
  [470, "TANZANIA"],
  [474, "TUNISIA"],
  [478, "EGYPT"],
  [480, "BURKINA FASO"],
  [482, "ZAMBIA"],
  [483, "TOGO"],
  [488, "WALVIS BAY"],
  [489, "CONWAY REEF"],
  [490, "BANABA I. (OCEAN I.)"],
  [492, "YEMEN"],
  [493, "PENGUIN IS."],
  [497, "CROATIA"],
  [499, "SLOVENIA"],
  [501, "BOSNIA-HERZEGOVINA"],
  [502, "NORTH MACEDONIA (REPUBLIC OF)"],
  [503, "CZECH REPUBLIC"],
  [504, "SLOVAK REPUBLIC"],
  [505, "PRATAS I."],
  [506, "SCARBOROUGH REEF"],
  [507, "TEMOTU PROVINCE"],
  [508, "AUSTRAL I."],
  [509, "MARQUESAS IS."],
  [510, "PALESTINE"],
  [511, "TIMOR-LESTE"],
  [512, "CHESTERFIELD IS."],
  [513, "DUCIE I."],
  [514, "MONTENEGRO"],
  [515, "SWAINS I."],
  [516, "SAINT BARTHELEMY"],
  [517, "CURACAO"],
  [518, "SINT MAARTEN"],
  [519, "SABA & ST. EUSTATIUS"],
  [520, "BONAIRE"],
  [521, "SOUTH SUDAN (REPUBLIC OF)"],
  [522, "REPUBLIC OF KOSOVO"],
]);
// cSpell:enable

export const DXCC_UNITED_STATES = 291;
export const DXCC_PUERTO_RICO = 202;

/**
 * Common non-standard country name aliases mapped to their DXCC codes.
 * These are names commonly returned by lookup services (QRZ, HamQTH, HamDB)
 * that differ from the official ADIF entity names.
 */
export const COUNTRY_NAME_ALIASES: Record<string, number> = {
  // United States variations
  "UNITED STATES": DXCC_UNITED_STATES,
  "USA": DXCC_UNITED_STATES,
  "US": DXCC_UNITED_STATES,
  "U.S.A.": DXCC_UNITED_STATES,
  "U.S.": DXCC_UNITED_STATES,

  // Czech Republic is already correct in ADIF but include common variations
  "CZECHIA": 503,

  // South Korea
  "SOUTH KOREA": 137,
  "KOREA": 137,

  // North Korea
  "NORTH KOREA": 344,

  // Russia variations
  "RUSSIA": 54,
  "RUSSIAN FEDERATION": 54,

  // UK constituent countries are separate DXCC entities, but services may return "United Kingdom"
  "UNITED KINGDOM": 223,
  "UK": 223,
  "GREAT BRITAIN": 223,

  // Taiwan
  "CHINESE TAIPEI": 386,
  "REPUBLIC OF CHINA": 386,

  // Congo variations
  "CONGO": 412,
  "REPUBLIC OF CONGO": 412,
  "DEM. REP. OF THE CONGO": 414,
  "DR CONGO": 414,
  "ZAIRE": 414,

  // Myanmar/Burma
  "BURMA": 309,

  // Cote d'Ivoire
  "IVORY COAST": 428,

  // Eswatini
  "SWAZILAND": 468,

  // North Macedonia
  "MACEDONIA": 502,
  "NORTH MACEDONIA": 502,
  "REPUBLIC OF NORTH MACEDONIA": 502,

  // Vietnam
  "VIETNAM": 293,

  // Iran
  "ISLAMIC REPUBLIC OF IRAN": 330,

  // Syria
  "SYRIAN ARAB REPUBLIC": 384,

  // South Africa
  "SOUTH AFRICA": 462,

  // UAE
  "UAE": 391,

  // Others commonly seen
  "PEOPLES REPUBLIC OF CHINA": 318,
  "PEOPLE'S REPUBLIC OF CHINA": 318,
  "P.R. CHINA": 318,
  "BRUNEI": 345,
  "EAST TIMOR": 511,
  "TIMOR LESTE": 511,
  "BOSNIA AND HERZEGOVINA": 501,
  "BOSNIA & HERZEGOVINA": 501,
  "TRINIDAD AND TOBAGO": 90,
  "ANTIGUA AND BARBUDA": 94,
  "ST KITTS AND NEVIS": 249,
  "SAINT KITTS AND NEVIS": 249,
  "SAINT LUCIA": 97,
  "SAINT VINCENT": 98,
  "SAINT VINCENT AND THE GRENADINES": 98,
  "SAINT HELENA": 250,
  "VATICAN CITY": 295,
  "HOLY SEE": 295,
  "MICRONESIA, FEDERATED STATES OF": 173,
  "FEDERATED STATES OF MICRONESIA": 173,
  "MARSHALL ISLANDS": 168,
  "SOLOMON ISLANDS": 185,
  "SOUTH SUDAN": 521,
  "KOSOVO": 522,
  "GAMBIA": 422,

  // Names collected from "Unrecognized DXCC country name" lookup-service
  // reports (primarily QRZ). Each maps a service's non-ADIF name to its DXCC
  // code; the canonical ADIF name (in DXCC_ENTITIES, shown in comments) is what
  // gets stored on the QSO. "ST"/"ST." saint variants are both included since
  // services are inconsistent about the period.
  "CANARY ISLANDS": 29,            // CANARY IS.
  "BALEARIC ISLANDS": 21,          // BALEARIC IS.
  "CEUTA AND MELILLA": 32,         // CEUTA & MELILLA
  "CAYMAN ISLANDS": 69,            // CAYMAN IS.
  "GALAPAGOS ISLANDS": 71,         // GALAPAGOS IS.
  "FAROE ISLANDS": 222,            // FAROE IS.
  "MADEIRA ISLAND": 256,           // MADEIRA IS.
  "US VIRGIN ISLANDS": 285,        // VIRGIN IS. (US, KP2 -- not British, 65)
  "AUSTRAL ISLANDS": 508,          // AUSTRAL I.
  "MARQUESAS ISLANDS": 509,        // MARQUESAS IS.
  "PITCAIRN ISLANDS": 172,         // PITCAIRN I.
  "LORD HOWE ISLAND": 147,         // LORD HOWE I.
  "RODRIGUEZ ISLAND": 207,         // RODRIGUES I. (service spells with a Z)
  "SABLE ISLAND": 211,             // SABLE I.
  "EASTER ISLAND": 47,             // EASTER I.
  "CENTRAL KIRIBATI": 31,          // C. KIRIBATI (BRITISH PHOENIX IS.)
  "CENTRAL AFRICAN REPUBLIC": 408, // CENTRAL AFRICA
  "MACAU": 152,                    // MACAO (service spells with a U)
  "REUNION": 453,                  // REUNION I.
  "ST LUCIA": 97,                  // ST. LUCIA  (SAINT LUCIA already mapped)
  "ST VINCENT": 98,                // ST. VINCENT (SAINT VINCENT already mapped)
  "ST MARTIN": 213,                // SAINT MARTIN (French, FS)
  "ST. MARTIN": 213,               // SAINT MARTIN (French, FS)
  "ST MAARTEN": 518,               // SINT MAARTEN (Dutch, PJ7)
  "ST. MAARTEN": 518,              // SINT MAARTEN (Dutch, PJ7)
};

const US_COUNTRY_NAMES: Set<string> = new Set([
  "UNITED STATES OF AMERICA",
  "UNITED STATES",
  "USA",
  "US",
  "U.S.A.",
  "U.S.",
]);

const PR_COUNTRY_NAMES: Set<string> = new Set([
  "PUERTO RICO",
]);

// Pre-computed set of canonical DXCC entity names for O(1) lookup
const DXCC_ENTITY_NAMES: Set<string> = new Set(DXCC_ENTITIES.values());

/**
 * Check if a country name is a known DXCC entity or alias.
 */
export function isKnownDxccEntity(country: string): boolean {
  const upper = country.trim().toUpperCase();
  return DXCC_ENTITY_NAMES.has(upper) || upper in COUNTRY_NAME_ALIASES;
}

/**
 * Look up the canonical ADIF entity name from a DXCC numeric code.
 */
export function getCanonicalCountryFromDxcc(dxccCode: number): string | undefined {
  return DXCC_ENTITIES.get(dxccCode);
}

/**
 * Resolve the canonical ADIF country name using DXCC code first, falling back
 * to string-based alias matching.
 */
export function resolveCanonicalCountry(
  dxcc: number | undefined,
  country: string | undefined
): string {
  if (dxcc) {
    return getCanonicalCountryFromDxcc(dxcc) ?? normalizeCountryName(country ?? '');
  }
  return normalizeCountryName(country ?? '');
}

/**
 * Detect when a QSO appears to be from Puerto Rico but is mislabeled as US.
 * Some lookup services (QRZ, HamQTH, HamDB) return DXCC 291 (US) for Puerto
 * Rico stations. Returns true when any of the following apply:
 *  - state is 'PR' and DXCC is 291 or absent
 *  - country is 'PUERTO RICO' but DXCC is 291
 *  - country is a US variant and state is 'PR' (regardless of DXCC)
 *
 * Returns true when correction is needed - the caller should set the DXCC
 * code to 202 and country to "PUERTO RICO".
 */
export function isPuertoRicoMislabeledAsUS(
  state: string | undefined,
  country: string | undefined,
  dxcc: number | undefined
): boolean {
  if (dxcc === DXCC_PUERTO_RICO) return false;

  // Defensive: legacy QSOs may have non-string state/country values
  // (e.g. a number from XML lookup auto-coercion). `.trim()` would throw.
  const stateString = typeof state === 'string' ? state : state == null ? undefined : String(state);
  const countryString = typeof country === 'string' ? country : country == null ? undefined : String(country);

  const upperState = stateString?.trim().toUpperCase();
  const upperCountry = countryString?.trim().toUpperCase();

  const stateIsPR = upperState === 'PR';
  const countryIsPR = upperCountry !== undefined && PR_COUNTRY_NAMES.has(upperCountry);
  const dxccIsUSOrMissing = dxcc === DXCC_UNITED_STATES || dxcc === undefined;
  const countryIsUS = upperCountry !== undefined && US_COUNTRY_NAMES.has(upperCountry);

  // State says PR and DXCC is US or unset
  if (stateIsPR && dxccIsUSOrMissing) return true;

  // Country already says Puerto Rico but DXCC incorrectly says US or is absent
  if (countryIsPR && dxccIsUSOrMissing) return true;

  // Country says US but state says PR - catches inconsistent data where DXCC
  // is set to some unrelated entity (e.g., dxcc=1 for Canada). The combination
  // of country=US + state=PR is a strong signal this is Puerto Rico.
  if (countryIsUS && stateIsPR) return true;

  return false;
}

/**
 * Normalize a country name to the official ADIF 3.1.6 DXCC entity name.
 *
 * First checks against the alias map. If no alias match is found,
 * checks if the name already matches an existing DXCC entity name.
 * Returns the original name if no mapping exists.
 */
export function normalizeCountryName(country: string): string {
  if (!country || typeof country !== "string") {
    return '';
  }

  const upperCountry = country.trim().toUpperCase();
  if (!upperCountry) {
    return '';
  }

  // Check alias map first
  const dxccCode = COUNTRY_NAME_ALIASES[upperCountry];
  if (dxccCode !== undefined) {
    return DXCC_ENTITIES.get(dxccCode) ?? upperCountry;
  }

  // Already a valid DXCC entity name? Return as-is (uppercased)
  if (DXCC_ENTITY_NAMES.has(upperCountry)) {
    return upperCountry;
  }

  // No match found, return uppercased input
  return upperCountry;
}
